import React, { useState } from "react";
import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { toastMessage } from "../../../../utils/toastMessage";
import { LoadingButton } from "../../../../Components/header/form";


const CheckoutForm = ({ clientSecret, plainDetails, setPaymentModal, detailPageRefresh = () => { }, setPage = 1, setHasMore = true, type }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  //---------handle-subscription-----------------
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    if (!stripe || !elements) {
      setMessage("Stripe has not loaded yet.");
      setLoading(false);
      return;
    }

    const cardElement = elements.getElement(CardElement);

    const { paymentIntent, error } = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: cardElement,
      },
    });
    if (error) {
      setMessage(error.message);
    } else if (paymentIntent.status === "succeeded") {
      setPaymentModal(false)
      if (type === 'list') {
        // console.log('here type in side')
        setPage(1)
        setHasMore(true)
        setTimeout(() => {
          detailPageRefresh(1, true); // Refresh after 1 second
        }, 1000);
      } else {
        setTimeout(() => {
          detailPageRefresh(); // Refresh after 1 second
        }, 1000);
      }
      toastMessage('Subscription created successfully!', 'success', 'SubscriptionCreatedSuccessfully')
    } else {
      setMessage("Processing payment...");
    }

    setLoading(false);
  };

  return (
    <>
      <CardElement className="strip_card_view" options={{ classes: { empty: "input" } }} />
      {message && <div className="text-danger mt-3">{message}</div>}

      <LoadingButton
        className="mt-4 mb-3"
        isDisabled={!stripe}
        onClick={handleSubmit}
        loading={loading}
      >
        Pay Now - {plainDetails?.currency} {plainDetails?.price}
      </LoadingButton>
    </>
  );
};

export default CheckoutForm;
